import React, { useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import axios from "axios";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const VoiceRecorder = () => {
    useTheme();

    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
            });

            const mimeType = MediaRecorder.isTypeSupported("audio/wav")
                ? "audio/wav"
                : "audio/webm";

            const recorder = new MediaRecorder(stream, { mimeType });
            const chunks = [];

            recorder.ondataavailable = (event) => {
                chunks.push(event.data);
            };

            recorder.onstop = async () => {
                const audioBlob = new Blob(chunks, { type: "audio/wav" });
                setAudioBlob(audioBlob);

                const url = URL.createObjectURL(audioBlob);
                setAudioUrl(url);

                await saveRecording(audioBlob, url);
            };

            recorder.start();
            setMediaRecorder(recorder);
      
            setIsRecording(true);
            setIsPaused(false);
        } catch (error) {
            console.error("Error starting recording:", error);
        }
    };

    const pauseRecording = () => {
        if (mediaRecorder && mediaRecorder.state === "recording") {
            mediaRecorder.pause();
            setIsPaused(true);
        }
    };

    const resumeRecording = () => {
        if (mediaRecorder && mediaRecorder.state === "paused") {
            mediaRecorder.resume();
            setIsPaused(false);
        }
    };

    const stopRecording = () => {
        if (
            mediaRecorder &&
            (mediaRecorder.state === "recording" ||
                mediaRecorder.state === "paused")
        ) {
            mediaRecorder.stop();
            mediaRecorder.stream.getTracks().forEach((track) => track.stop());
            setIsRecording(false);
            setIsPaused(false);
        }
    };

    const saveRecording = async (audioBlob, url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const file = new File([blob], "recording.wav", {
                type: "audio/wav",
            });

            const formData = new FormData();
            formData.append("file", file);

            await axios.post(
                "http://127.0.0.1:8000/api/audio/upload",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
        } catch (error) {
            console.error("Error saving recording:", error);
        }
    };

    const downloadRecording = () => {
        if (!audioBlob) return;

        const downloadUrl = URL.createObjectURL(audioBlob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "recording.wav";
        a.click();
        URL.revokeObjectURL(downloadUrl);
    };

    return (
        <>
            <HeaderSection toolId="voiceRecorderOnline" />
            <main className="max-w-4xl mx-auto p-4  lg:max-w-full lg:px-4">
                <article className="bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 rounded-xl shadow-sm dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 overflow-hidden">
                    <div className="bg-gradient-to-r from-green-500 to-green-600 p-6  text-white">
                        <h1 className="text-2xl font-bold mb-2 flex items-center">
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="mr-3"
                            />
                            Voice Recorder
                        </h1>
                        <p className="opacity-90">
                            Record, pause, and download audio clips
                        </p>
                    </div>
                    <section className="bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 p-6">
                        <header className="mb-6">
                            <h1 className="text-2xl font-semibold  dark:text-white">
                                Voice Recorder
                            </h1>
                            <p className="text-gray-600 dark:text-gray-100 dark:text-gray-100 dark:text-gray-100 dark:text-gray-100 dark:text-gray-300 dark:text-gray-300 mt-2">
                                Record, pause, and download audio clips
                            </p>
                        </header>

                        <menu className="flex flex-wrap gap-4 mb-6">
                            <li>
                                <button
                                    className={`px-4 py-2 rounded-md font-medium transition-colors ${
                                        isRecording
                                            ? "bg-gray-200 text-gray-500 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-400 dark:text-gray-400 cursor-not-allowed"
                                            : "bg-green-500 text-white hover:bg-green-600 focus:ring-2 focus:ring-green-200"
                                    }`}
                                    onClick={startRecording}
                                    disabled={isRecording}
                                    aria-label={
                                        isRecording
                                            ? "Recording in progress"
                                            : "Start recording"
                                    }
                                >
                                    {isRecording
                                        ? "🎙️ Recording..."
                                        : "🎤 Record"}
                                </button>
                            </li>

                            <li>
                                <button
                                    className={`px-4 py-2 rounded-md font-medium transition-colors ${
                                        !isRecording
                                            ? "bg-gray-200 text-gray-500 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-400 dark:text-gray-400 cursor-not-allowed"
                                            : "bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-200"
                                    }`}
                                    onClick={
                                        isPaused
                                            ? resumeRecording
                                            : pauseRecording
                                    }
                                    disabled={!isRecording}
                                    aria-label={
                                        isPaused
                                            ? "Resume recording"
                                            : "Pause recording"
                                    }
                                >
                                    {isPaused ? "▶️ Resume" : "⏸️ Pause"}
                                </button>
                            </li>

                            <li>
                                <button
                                    className={`px-4 py-2 rounded-md font-medium transition-colors ${
                                        !isRecording
                                            ? "bg-gray-200 text-gray-500 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-200 dark:text-gray-400 dark:text-gray-400 cursor-not-allowed"
                                            : "bg-red-500 text-white hover:bg-red-600 focus:ring-2 focus:ring-red-200"
                                    }`}
                                    onClick={stopRecording}
                                    disabled={!isRecording}
                                    aria-label="Stop recording"
                                >
                                    ⏹️ Stop
                                </button>
                            </li>
                        </menu>

                        {audioUrl && (
                            <section
                                className="mb-6"
                                aria-labelledby="playback-heading"
                            >
                                <h2
                                    id="playback-heading"
                                    className="text-lg font-medium text-gray-800 dark:text-white dark:text-white dark:text-white dark:text-white dark:text-gray-100 dark:text-gray-100 mb-2"
                                >
                                    Listen to your recording:
                                </h2>
                                <audio
                                    controls
                                    className="w-full"
                                    aria-describedby="audio-help"
                                >
                                    <source src={audioUrl} type="audio/wav" />
                                    Your browser does not support the audio
                                    element.
                                </audio>
                                <p id="audio-help" className="sr-only">
                                    Audio playback controls
                                </p>
                            </section>
                        )}

                        {audioBlob && (
                            <section className="mt-4">
                                <button
                                    className="px-4 py-2 bg-green-500 text-white rounded-md font-medium hover:bg-green-600 focus:ring-2 focus:ring-green-200 transition-colors"
                                    onClick={downloadRecording}
                                    aria-label="Download recording"
                                >
                                    ⬇️ Download Recording
                                </button>
                            </section>
                        )}
                    </section>
                </article>
            </main>
            <BottomSection toolId="voiceRecorderOnline" />
        </>
    );
};

export default VoiceRecorder;